import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCurrencyEuro: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="currency-euro, money"><path d="M2.75 10.25H13.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square" strokeLinejoin="round"/><path d="M2.75 13.75H13.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square" strokeLinejoin="round"/><path d="M19.25 6.03917C17.7428 4.0277 15.4873 2.75 12.9667 2.75C8.42873 2.75 4.75 6.89137 4.75 12C4.75 17.1086 8.42873 21.25 12.9667 21.25C15.4873 21.25 17.7428 19.9723 19.25 17.9608" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconCurrencyEuro;
